// import moment from 'moment'
import React from 'react'
let moment = require('moment-timezone');

// import { checkTextTranslation } from '../../utils/useful'

class TableDateInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        let format = 'YYYY/MM/DD'
        if (this.props.header.information?.time) {
            format = format + ' (hh:mm)'
        }
        return (
            <div className="w-100 h-100 flexcc">
                {this.props.data && (
                    <p className="" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{moment(this.props.data).tz('Asia/Singapore').format(format)}</p>
                )}
            </div>
        )
    }
}

export default TableDateInput;